const UserDetailsScreen: React.FC<any> = (props: any) => {
  return <div>User details</div>;
};

export default UserDetailsScreen;
